import type { ButtonProps, Size, Variant } from './interfaces'

type VariantCssClasses = {
  base: {
    background?: string
    text?: string
    border?: string
    outline?: string
  }
  hover: {
    background?: string
    text?: string
    border?: string
  }
}

export const getColorClassesByVariant = (
  variant: Variant,
  tone: ButtonProps['tone'] = 'default'
): VariantCssClasses => {
  const baseColorMap: Record<Variant, VariantCssClasses> = {
    primary: {
      base: {
        background: 'bg-yellow-400',
        text: 'text-base-700',
        border: 'border-1 border-yellow-400',
        outline:
          'focus-visible:outline-yellow focus-visible:border-yellow-800 focus-visible:border',
      },
      hover: {
        background: 'hover:bg-yellow-200',
        border: 'hover:border-yellow-200',
      },
    },
    secondary: {
      base: {
        background: 'bg-transparent',
        text: 'text-gold-600',
        border: 'border-1 border-gold-600',
        outline:
          'focus-visible:outline-gold focus-visible:border-gold-800 focus-visible:border',
      },
      hover: {
        border: 'hover:border-base-700',
        text: 'hover:text-base-700',
      },
    },
    danger: {
      base: {
        background: 'bg-RAGred',
        text: 'text-gold-40',
        border: 'border-1 border-RAGred',
        outline:
          'focus-visible:outline-red focus-visible:border-red-800 focus-visible:border',
      },
      hover: {
        background: 'hover:bg-red-400',
        border: 'hover:border-red-400',
      },
    },
    link: {
      base: {
        background: 'bg-transparent',
        text: 'text-gold-600',
        border: '',
        outline: '',
      },
      hover: {
        text: 'hover:text-base-700 hover:underline',
      },
    },
    icon: {
      base: {
        background: '',
        text: 'text-base-700',
        border: 'border-none',
        outline: '',
      },
      hover: {
        text: 'hover:text-maroon-500',
      },
    },
  }

  const selectedVariantClasses = baseColorMap[variant]

  if (!selectedVariantClasses) {
    return { base: {}, hover: {} }
  }

  const finalClasses: VariantCssClasses = {
    base: { ...selectedVariantClasses.base },
    hover: { ...selectedVariantClasses.hover },
  }

  if (variant === 'link') {
    if (tone === 'dark') {
      finalClasses.base.text = 'text-base-700'
      finalClasses.hover.text = 'hover:text-base-700'
    } else if (tone === 'light') {
      finalClasses.base.text = 'text-white'
      finalClasses.hover.text = 'hover:text-white hover:underline'
    }
  }

  return finalClasses
}

export const paddingPerSize: Record<Size, string> = {
  small: 'py-2 px-3',
  medium: 'py-3 px-4',
}

export const heightPerSize: Record<Size, string> = {
  small: '27px',
  medium: '40px',
}

export const fontSizePerSize: Record<Size, string> = {
  small: 'text-xs',
  medium: 'text-sm',
}
